module.exports = __webpack_public_path__ + "img/ic_publicity_detail8_1.1226d0c2.jpg";